module.exports = __webpack_public_path__ + "img/video_game4.2fd5937f.png";